var Social = function(){

    'use strict';

    var $ = jQuery,
        instances = [];

    function onReady() {
        $('.module.social').each(function () {
            instances.push(new Social($(this)));
        });
    }

    function Social(view) {

        var $view = view,
        url = $view.find('.tpl-social').data('url'),
        title = $view.find('.tpl-social').data('title');

        function init() {
            bind()
            return this;
        }

        function onClick(e) {
            e.preventDefault();

            if($(this).hasClass('fb')) {
                var socialWeb = 'fb';
            } else if($(this).hasClass('tw')) {
                var socialWeb = 'tw';
            } else if($(this).hasClass('whatsapp')) {
                var socialWeb = 'whatsapp';
            } else {
                var socialWeb = 'mail';
            }

            var winFeatures = "menubar=no,location=no,resizable=yes,scrollbars=no,status=no,width=750,height=320";
            var formatedURL = '';

            if (socialWeb === 'fb') {
                formatedURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
                var win = window.open(formatedURL, 'social' + socialWeb, winFeatures);
            }
            else if (socialWeb === 'tw') {
                formatedURL = 'https://twitter.com/intent/tweet?&text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url);
                var win = window.open(formatedURL, 'social' + socialWeb, winFeatures);
            }
            else if (socialWeb === 'mail') {
                location.href = 'mailto:?subject='+title+' &body=Mira este artículo que he encontrado en empantallados.com:  ' + url;
                return false;
            }
            else if (socialWeb === 'whatsapp') {
                location.href = 'whatsapp://send?text=Te comparto este artículo de empantallados.com: ' + url;
                return false;
            }
        }

        function bind() {
            $view.find('a').on('click', onClick);
            var top = $view.offset().top;
            
            if ($('body').hasClass('t-desktop')) {
                $(window).scroll(function () {
                    if ($(window).scrollTop() + ($('#menu').height() + 10) >= top) {
                        $view.addClass('sticky');
                    }
                    else if ($(window).scrollTop() < top) {
                        $view.removeClass('sticky');
                    }
                });
            }
        }

        this.url = url;
        this.title = title;
        this.init = init;
        return this.init();
    }

    // DOMContentLoaded
    $(onReady);

}

Social();
